import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import icfLogo from '../assets/icf_logo.png';
import hadiyaLogo from '../assets/hadiya-logo-web.png';

export default function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!username.trim() || !password.trim()) {
      setError('Username and password are required');
      return;
    }

    setLoading(true);
    try {
      const { data } = await api.post('/auth/admin-login', {
        username: username.trim(),
        password: password.trim()
      });
      localStorage.setItem('admin_token', data.token);
      localStorage.setItem('admin_user', JSON.stringify(data.user));
      navigate('/react-user/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid Credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logoSection}>
          <img src={hadiyaLogo} alt="Hadiya Logo" style={styles.logoImage} />
          <h1 style={styles.title}>User Portal</h1>
          <p style={styles.subtitle}>Sign in to access management tools</p>
        </div>
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Username</label>
            <input
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              style={styles.input}
              placeholder="Enter admin username"
              disabled={loading}
              autoComplete="off"
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              style={styles.input}
              placeholder="Enter password"
              disabled={loading}
            />
          </div>
          {error && <div style={styles.error}>{error}</div>}
          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? 'Authenticating...' : 'Secure Login'}
          </button>
        </form>
        <div style={styles.footer}>
          <img src={icfLogo} alt="ICF Logo" style={styles.footerLogo} />
          <p style={styles.footerText}>ICF INTERNATIONAL</p>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'linear-gradient(135deg, #fdf2f8 0%, #fbcfe8 50%, #f472b6 100%)',
    padding: '20px',
  },
  card: {
    background: 'rgba(255, 255, 255, 0.95)',
    padding: '48px 40px',
    borderRadius: '24px',
    boxShadow: '0 25px 50px -12px rgba(216, 27, 96, 0.25)',
    width: '100%',
    maxWidth: '440px',
  },
  logoSection: {
    textAlign: 'center',
    marginBottom: '32px',
  },
  logoImage: {
    height: '64px',
    marginBottom: '16px',
    objectFit: 'contain',
  },
  title: {
    margin: '0 0 8px',
    fontSize: '28px',
    fontWeight: '700',
    color: '#d81b60',
  },
  subtitle: {
    margin: 0,
    fontSize: '14px',
    color: '#831843',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  label: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#be185d',
    textTransform: 'uppercase',
  },
  input: {
    width: '100%',
    padding: '14px 16px',
    border: '2px solid #fbcfe8',
    borderRadius: '12px',
    fontSize: '15px',
    background: '#ffffff',
    color: '#831843',
    outline: 'none',
    transition: 'border-color 0.2s',
  },
  button: {
    padding: '16px',
    background: 'linear-gradient(135deg, #db2777 0%, #be185d 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    marginTop: '12px',
    boxShadow: '0 4px 14px rgba(219, 39, 119, 0.4)',
  },
  error: {
    background: '#fef2f2',
    color: '#dc2626',
    padding: '12px',
    borderRadius: '8px',
    fontSize: '14px',
    borderLeft: '4px solid #dc2626',
  },
  footer: {
    marginTop: '32px',
    textAlign: 'center',
    borderTop: '1px solid rgba(216, 27, 96, 0.1)',
    paddingTop: '20px',
  },
  footerLogo: {
    height: '40px',
    marginBottom: '8px',
  },
  footerText: {
    margin: 0,
    fontSize: '12px',
    color: '#831843',
    fontWeight: '600',
    letterSpacing: '1px',
  },
};
